import script from "./ActivitiesList.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivitiesList.vue?vue&type=script&setup=true&lang=js"

import "./ActivitiesList.vue?vue&type=style&index=0&id=33bc553f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33bc553f"]])

export default __exports__